(() => {
  if (customElements.get('lp-product-lightbox')) return;
  class ProductLightbox extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const on = (el, type, fn, options = {}) => el.addEventListener(type, fn, {...options, signal: this.abort.signal});
      this.stage = this.querySelector('[data-stage]');
      this.track = this.querySelector('[data-track]');
      this.thumbs = this.querySelector('[data-thumbs]');
      this.zoomButton = this.querySelector('[data-zoom]');
      this.pointers = new Map(); this.index = 0; this.scale = 1; this.x = 0; this.y = 0;
      this.catalog = JSON.parse(this.querySelector('[data-images]').textContent);
      on(document, 'click', e => {
        const item = e.target.closest(`#${this.dataset.gallery} .product__media-item[data-media-id]`);
        if (!item || !this.catalog[item.dataset.mediaId.split('-').pop()]) return;
        e.preventDefault(); e.stopImmediatePropagation(); this.open(item);
      }, {capture: true});
      on(this.querySelector('[data-close]'), 'click', () => this.close());
      on(this.querySelector('[data-prev]'), 'click', () => this.go(this.index - 1));
      on(this.querySelector('[data-next]'), 'click', () => this.go(this.index + 1));
      on(this.zoomButton, 'click', () => this.zoom());
      on(this, 'click', e => { if (e.target === this) this.close(); });
      on(this.stage, 'pointerdown', e => this.down(e));
      on(this.stage, 'pointermove', e => this.move(e));
      on(this.stage, 'pointerup', e => this.up(e));
      on(this.stage, 'pointercancel', e => this.up(e, true));
      on(this.stage, 'dblclick', e => { e.preventDefault(); if (e.pointerType !== 'touch') this.zoom(); });
      on(this.stage, 'dragstart', e => e.preventDefault());
      on(document, 'keydown', e => {
        if (this.hidden) return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        if (e.key === 'Tab') {
          const buttons = [...this.querySelectorAll('button:not(:disabled)')];
          const first = buttons[0], last = buttons[buttons.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
      on(window, 'resize', () => { if (!this.hidden) { this.pointers.clear(); this.go(this.index, false); } });
    }
    disconnectedCallback() { if (!this.hidden) this.close(); this.abort?.abort(); this.abort = null; }
    open(item) {
      this.images = [...document.getElementById(this.dataset.gallery).querySelectorAll('.product__media-list .product__media-item[data-media-id]')]
        .filter(el => !el.hidden && !el.classList.contains('hidden'))
        .map(el => ({id: el.dataset.mediaId.split('-').pop(), ...this.catalog[el.dataset.mediaId.split('-').pop()]}))
        .filter(image => image.src);
      if (!this.images.length) return;
      this.returnFocus = document.activeElement;
      this.track.replaceChildren(); this.thumbs.replaceChildren();
      this.images.forEach((image, i) => {
        const slide = document.createElement('div'); slide.className = 'lplb__slide';
        const img = document.createElement('img'); img.dataset.full = image.src; img.src = image.src.replace(/([?&])width=\d+/, '$1width=1200'); img.alt = image.alt || ''; img.width = image.width; img.height = image.height;
        img.draggable = false; img.decoding = 'async'; img.loading = i === 0 ? 'eager' : 'lazy'; slide.append(img); this.track.append(slide);
        const button = document.createElement('button'); button.type = 'button'; button.setAttribute('aria-label', `${this.dataset.loadLabel} ${i + 1}`);
        const thumb = document.createElement('img'); thumb.src = image.thumb; thumb.alt = ''; thumb.width = 52; thumb.height = 52;
        button.append(thumb); button.addEventListener('click', () => this.go(i)); this.thumbs.append(button);
      });
      this.savedScroll = window.scrollY; this.savedBody = {};
      for (const key of ['position', 'top', 'width', 'overflow']) { this.savedBody[key] = document.body.style[key]; }
      Object.assign(document.body.style, {position: 'fixed', top: `-${this.savedScroll}px`, width: '100%', overflow: 'hidden'});
      this.hidden = false; this.lastTap = 0; this.pointers.clear();
      this.go(Math.max(0, this.images.findIndex(image => image.id === item.dataset.mediaId.split('-').pop())), false);
      this.querySelector('[data-close]').focus({preventScroll: true});
    }
    close() {
      if (this.hidden) return;
      this.hidden = true; cancelAnimationFrame(this.frame); cancelAnimationFrame(this.settleFrame); this.pointers.clear(); Object.assign(document.body.style, this.savedBody);
      window.scrollTo(0, this.savedScroll); this.returnFocus?.focus({preventScroll: true});
    }
    go(index, animate = true) {
      cancelAnimationFrame(this.frame); cancelAnimationFrame(this.settleFrame); this.frame = null; this.pendingOffset = null;
      this.rect = this.stage.getBoundingClientRect(); this.width = this.rect.width; this.height = this.rect.height;
      this.index = Math.max(0, Math.min(this.images.length - 1, index));
      this.scale = 1; this.x = 0; this.y = 0; this.drag = 0;
      this.track.classList.toggle('is-dragging', !animate);
      this.track.style.transform = `translate3d(${-this.index * this.width}px,0,0)`;
      [...this.track.children].forEach((slide, i) => { slide.setAttribute('aria-hidden', String(i !== this.index)); slide.firstChild.style.transform = ''; });
      [...this.thumbs.children].forEach((button, i) => button.setAttribute('aria-current', String(i === this.index)));
      const thumb = this.thumbs.children[this.index];
      if (thumb) this.thumbs.scrollTo({left: thumb.offsetLeft - this.thumbs.offsetLeft - (this.thumbs.clientWidth - thumb.offsetWidth) / 2, behavior: 'instant'});
      this.querySelector('[data-prev]').disabled = this.index === 0;
      this.querySelector('[data-next]').disabled = this.index === this.images.length - 1;
      this.querySelector('[data-count]').textContent = `${this.index + 1} / ${this.images.length}`;
      for (const i of [this.index, this.index - 1, this.index + 1]) {
        const image = this.track.children[i]?.firstChild;
        if (image) { image.loading = 'eager'; image.decode?.().catch(() => {}); }
      }
      this.paint();
    }
    paint() {
      const img = this.track.children[this.index]?.firstChild; if (!img) return;
      const w = this.width, h = this.height;
      const fit = Math.min(w / (img.naturalWidth || img.width), h / (img.naturalHeight || img.height));
      const maxX = Math.max(0, ((img.naturalWidth || img.width) * fit * this.scale - w) / 2);
      const maxY = Math.max(0, ((img.naturalHeight || img.height) * fit * this.scale - h) / 2);
      this.x = Math.max(-maxX, Math.min(maxX, this.x)); this.y = Math.max(-maxY, Math.min(maxY, this.y));
      img.style.transform = `translate3d(${this.x}px,${this.y}px,0) scale(${this.scale})`;
      this.zoomButton.setAttribute('aria-label', this.scale > 1 ? this.dataset.zoomOut : this.dataset.zoomIn);
      this.zoomButton.setAttribute('aria-pressed', String(this.scale > 1));
      this.zoomButton.textContent = this.scale > 1 ? '−' : '+';
      this.stage.classList.toggle('is-zoomed', this.scale > 1);
    }
    zoom() { this.scale = this.scale > 1 ? 1 : 2.5; this.x = this.y = 0; this.loadZoom(); this.paint(); }
    loadZoom() {
      const image = this.track.children[this.index]?.firstChild;
      if (this.scale > 1 && image?.dataset.full && !image.dataset.upgraded) {
        image.dataset.upgraded = 'true';
        const preload = new Image(); preload.src = image.dataset.full;
        preload.decode().then(() => { if (image.isConnected) image.src = preload.src; }).catch(() => {});
      }
    }
    queuePaint(offset) {
      this.pendingOffset = offset;
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.pendingOffset !== null) this.track.style.transform = `translate3d(${this.pendingOffset}px,0,0)`;
        else this.paint();
      });
    }
    point(e) { return {x: e.clientX, y: e.clientY}; }
    distance() { const [a,b] = [...this.pointers.values()]; return Math.hypot(a.x-b.x, a.y-b.y); }
    midpoint() { const [a,b] = [...this.pointers.values()]; const rect = this.rect; return {x:(a.x+b.x)/2-rect.left-rect.width/2, y:(a.y+b.y)/2-rect.top-rect.height/2}; }
    down(e) {
      if (e.button !== 0) return;
      cancelAnimationFrame(this.frame); cancelAnimationFrame(this.settleFrame); this.frame = null; this.pendingOffset = null;
      if (!this.pointers.size) {
        this.rect = this.stage.getBoundingClientRect(); this.width = this.rect.width; this.height = this.rect.height;
        const transform = getComputedStyle(this.track).transform;
        this.dragBase = transform === 'none' ? -this.index * this.width : new DOMMatrixReadOnly(transform).m41;
        this.track.classList.add('is-dragging');
        this.track.style.transform = `translate3d(${this.dragBase}px,0,0)`;
        this.velocity = 0; this.lastTime = e.timeStamp;
      }
      this.stage.setPointerCapture(e.pointerId); this.pointers.set(e.pointerId, this.point(e));
      this.track.classList.add('is-dragging'); this.last = this.point(e); this.start = this.point(e); this.drag = 0; this.moved = false;
      if (this.pointers.size === 2) {
        this.pinching = true; this.lastTap = 0; this.pinchDistance = this.distance(); this.pinchScale = this.scale;
        this.pinchMid = this.midpoint(); this.pinchX = this.x; this.pinchY = this.y;
        this.track.style.transform = `translate3d(${-this.index * this.width}px,0,0)`;
      }
    }
    move(e) {
      if (!this.pointers.has(e.pointerId)) return; e.preventDefault();
      this.pointers.set(e.pointerId, this.point(e));
      if (this.pointers.size >= 2) {
        const mid = this.midpoint(); this.scale = Math.max(1, Math.min(4, this.pinchScale * this.distance() / Math.max(1,this.pinchDistance)));
        const ratio = this.scale / this.pinchScale;
        this.x = mid.x - (this.pinchMid.x - this.pinchX) * ratio; this.y = mid.y - (this.pinchMid.y - this.pinchY) * ratio; this.queuePaint(null);
      } else {
        const dx = e.clientX - this.last.x, dy = e.clientY - this.last.y;
        if (Math.hypot(e.clientX-this.start.x,e.clientY-this.start.y) > 8) this.moved = true;
        if (this.scale > 1) { this.x += dx; this.y += dy; this.queuePaint(null); }
        else if (!this.pinching) {
          this.drag = e.clientX - this.start.x;
          const edge = (this.index === 0 && this.drag > 0) || (this.index === this.images.length-1 && this.drag < 0);
          this.queuePaint(this.dragBase + this.drag * (edge ? 0.25 : 1));
          const dt = e.timeStamp - this.lastTime;
          if (dt > 0) this.velocity = dx / dt;
        }
        this.last = this.point(e); this.lastTime = e.timeStamp;
      }
    }
    up(e, cancelled = false) {
      if (!this.pointers.has(e.pointerId)) return;
      this.pointers.delete(e.pointerId);
      if (this.pointers.size) { this.last = [...this.pointers.values()][0]; this.start = this.last; return; }
      cancelAnimationFrame(this.frame); this.frame = null;
      if (this.pinching) {
        this.pinching = false; this.drag = 0;
        if (this.scale < 1.05) { this.scale=1; this.x=this.y=0; }
        this.loadZoom(); this.paint(); return;
      }
      // Commit the final finger position before starting the settling transition.
      if (this.scale === 1 && this.pendingOffset != null) this.track.style.transform = `translate3d(${this.pendingOffset}px,0,0)`;
      this.pendingOffset = null;
      if (this.scale > 1) this.paint();
      const velocity = e.timeStamp - this.lastTime < 80 ? this.velocity : 0;
      const distance = this.drag || 0;
      const flick = Math.abs(distance) > 12 && Math.abs(velocity) > 0.35 && Math.sign(distance) === Math.sign(velocity);
      const advance = this.scale === 1 && !cancelled && (Math.abs(distance) > Math.min(65,this.width*0.16) || flick);
      const target = advance ? Math.max(0, Math.min(this.images.length-1, this.index + (distance < 0 ? 1 : -1))) : this.index;
      if (this.scale === 1) {
        // One frame preserves continuity even for a fast swipe between two paints.
        this.settleFrame = requestAnimationFrame(() => {
          this.settleFrame = null;
          this.go(target);
        });
      }
      if (!cancelled && !this.moved && e.pointerType === 'touch') {
        const now = Date.now();
        if (now-this.lastTap < 300) { cancelAnimationFrame(this.settleFrame); this.zoom(); this.lastTap=0; }
        else this.lastTap=now;
      }
      this.drag = 0;
    }
  }
  customElements.define('lp-product-lightbox', ProductLightbox);
})();
